import React from 'react';

import {CurrentPublishingRecordForListingPage} from 'template-collectibles/publishing-ui/graphql/types';
import {
  PUBLISHABLE_VERSION_STATUS_TO_COLOR,
  PUBLISHABLE_VERSION_STATUS_TO_ICON,
} from 'template-collectibles/publishing-ui/TemplatePublishingConstants';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {capitalize} from 'util/NameUtil';

export default function PublishingStatusRenderer({
  isPublishingSupportedForItemType,
  currentPublishingRecord,
}: {
  isPublishingSupportedForItemType: boolean;
  currentPublishingRecord: CurrentPublishingRecordForListingPage | null;
}): JSX.Element {
  if (!isPublishingSupportedForItemType) {
    return <span>--</span>;
  }
  if (!currentPublishingRecord) {
    return <span>Unpublished</span>;
  }
  const {publishingStatus, versionName} = currentPublishingRecord;
  return (
    <Tooltip text={capitalize(publishingStatus)}>
      <span>
        <span style={{color: PUBLISHABLE_VERSION_STATUS_TO_COLOR[publishingStatus]}}>
          <BenchlingIcon icon={PUBLISHABLE_VERSION_STATUS_TO_ICON[publishingStatus]} />
        </span>
        &nbsp;{versionName}
      </span>
    </Tooltip>
  );
}
